import { REVIEWERS_ACTIONS } from "./REVIEWERS_ACTIONS.js"


export function reviewersReducer(state, action) {
  switch (action.type) {
    case REVIEWERS_ACTIONS.SET_REVIEWERS:
      return {
        ...state,
        reviewers: action.payload.reviewers,
        pagination: action.payload.pagination,
      }
    case REVIEWERS_ACTIONS.SET_IS_LOADING:
      return { ...state, isLoading: action.payload.isLoading }
    default:
      return state
  }
}